/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class CreateDepositPassimPayRequestDto {
    /**
    * Сумма транзакции в формате \"100.00\"
    */
    'amount': string;
    /**
    * Уникальный номер заказа в нашей системе
    */
    'orderId': number;
    /**
    * Список валют через запятую (например, \"BTC,ETH,USDT\") (пока ни на что не влияет)
    */
    'currencies'?: string;
    /**
    * Код валюты ISO 4217 (например, \"USD\") в который конвертируем по умолчанию
    */
    'symbol'?: string;
    /**
    * Тип валют (0 - все, 1 - крипто, 2 - фиат)
    */
    'type'?: CreateDepositPassimPayRequestDtoTypeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "amount",
            "baseName": "amount",
            "type": "string",
            "format": ""
        },
        {
            "name": "orderId",
            "baseName": "orderId",
            "type": "number",
            "format": ""
        },
        {
            "name": "currencies",
            "baseName": "currencies",
            "type": "string",
            "format": ""
        },
        {
            "name": "symbol",
            "baseName": "symbol",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "CreateDepositPassimPayRequestDtoTypeEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CreateDepositPassimPayRequestDto.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum CreateDepositPassimPayRequestDtoTypeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

